import { useRouteError, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useLanguage } from '@shared/contexts/LanguageContext';

export default function ErrorPage({ error: propError }) {
  const { t } = useLanguage();
  const routeError = useRouteError();
  const navigate = useNavigate();

  // 錯誤頁不在 PageHeader 內，手動套用已存的字體偏好
  useEffect(() => {
    const saved = localStorage.getItem('preferred-font');
    const fontClass = saved === 'primary' ? 'font-round' : 'font-serif';
    document.body.classList.remove('font-round', 'font-serif');
    document.body.classList.add(fontClass);
  }, []);

  const error = routeError || propError;
  const is404 = error?.status === 404 || error?.statusText === 'Not Found';

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-[#faf8f3] p-8">
      <div className="text-center max-w-md">
        <p className="text-8xl font-bold text-[#c9a96e] mb-4">
          {is404 ? '404' : '500'}
        </p>
        <h1 className="text-3xl font-bold text-[#8b4513] mb-3">
          {is404 ? t('error-page.notFoundTitle') : t('error-page.errorTitle')}
        </h1>
        <p className="text-lg text-[#6b5447] mb-8">
          {is404 ? t('error-page.notFoundDesc') : t('error-page.errorDesc')}
        </p>

        {import.meta.env.DEV && error && (
          <div className="mb-8 text-left bg-[#f0e8d8] rounded-lg p-4 border border-[#c9a96e]">
            <p className="text-sm text-[#8b4513] font-medium mb-2">
              {t('error-page.devDetails')}
            </p>
            <pre className="text-xs text-[#6b5447] overflow-auto whitespace-pre-wrap break-all">
              {error.stack || error.message || JSON.stringify(error, null, 2)}
            </pre>
          </div>
        )}

        <button
          onClick={() => navigate('/')}
          className="px-8 py-3 bg-[#8b4513] text-white rounded-full text-lg hover:bg-[#7a3b10] transition-colors"
        >
          {t('error-page.backHome')}
        </button>
      </div>
    </div>
  );
}
